// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6c98ce78","455":"21f28f84","977":"84e63ac4"}[chunkId] + ".chunk.js";
};